import React from 'react';
import { PageLayout } from './PageLayout';

export interface CorePageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Layout principale dell'applicativo con main menu e side menu.
 */
export function CorePageLayout(props: CorePageLayoutProps) {
  // TODO Gestire visibilità menu visualizzazione elenco
  // TODO nascondere menu principale eliminando prop: hasMainMenu
  return (
    <PageLayout hasMainMenu className={props.className}>
      {props.children}
    </PageLayout>
  );
}
